"use client";

import { useContactForm } from "@/hooks/useContactForm";

export function ContactSection() {
  const {
    name,
    email,
    message,
    birthYear,
    optIn,
    website,
    setName,
    setEmail,
    setMessage,
    setBirthYear,
    setOptIn,
    setWebsite,
    needsBirthYear,
    loading,
    submitted,
    handleSubmit,
  } = useContactForm();
  return (
    <section
      id="contact"
      className="py-32 bg-surface-200 scroll-mt-20"
      style={{
        backgroundImage: "url(/images/marketing/home/contact/form-background.webp)",
        backgroundRepeat: "no-repeat",
        backgroundSize: "auto",
        backgroundPosition: "center",
      }}
    >
      <div className="container mx-auto px-4 max-w-3xl">
        <div className="mx-auto w-full max-w-[500px]">
          <div
            className="w-full"
            style={{
              borderStyle: "solid",
              borderWidth: "36px 8px 8px 8px",
              borderImage:
                "url(/images/marketing/home/contact/form-paper.webp) 36 8 8 8 fill stretch",
            }}
          >
            {submitted ? (
              <div className="px-8 py-72 sm:px-10 sm:py-80 space-y-2 text-center">
                <h2 className="text-2xl md:text-3xl font-extrabold">Thank you!</h2>
                <p className="text-base md:text-lg text-black/80 mt-2">
                  Messages sent by adults will be received.
                </p>
              </div>
            ) : (
              <form
                className="p-8 sm:p-10 space-y-3 md:space-y-4"
                onSubmit={handleSubmit}
                autoComplete="off"
              >
                {/* Heading + helper inside paper */}
                <div>
                  <h2 className="text-2xl md:text-3xl font-extrabold">Get in touch</h2>
                  <p className="text-base md:text-lg text-black/80 mt-2">
                    Have ideas or questions? Let us know!
                  </p>
                </div>
                {/* Name */}
                <div>
                  <label className="block text-black font-semibold mb-1" htmlFor="contact-name">
                    Name
                  </label>
                  <input
                    id="contact-name"
                    name="name"
                    type="text"
                    placeholder="Your full name"
                    className="w-full border-2 border-surface-300 rounded-2xl px-4 py-2"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                  />
                </div>

                {/* Email */}
                <div>
                  <label className="block text-black font-semibold mb-1" htmlFor="contact-email">
                    Email
                  </label>
                  <input
                    id="contact-email"
                    name="email"
                    type="email"
                    placeholder="me@school.com"
                    className="w-full border-2 border-surface-300 rounded-2xl px-4 py-2"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>

                {/* Message */}
                <div>
                  <label className="block text-black font-semibold mb-1" htmlFor="contact-message">
                    Message
                  </label>
                  <textarea
                    id="contact-message"
                    name="message"
                    rows={2}
                    placeholder="Your message..."
                    className="w-full border-2 border-surface-300 rounded-2xl px-4 py-2"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    required
                  />
                </div>

                {/* Birth year — skipped when an adult year is already on file */}
                {needsBirthYear ? (
                  <div>
                    <label
                      className="block text-black font-semibold mb-1"
                      htmlFor="contact-birthyear"
                    >
                      Birth year
                    </label>
                    <input
                      id="contact-birthyear"
                      name="birthYear"
                      type="text"
                      inputMode="numeric"
                      pattern="[0-9]{4}"
                      maxLength={4}
                      placeholder="Enter your birth year"
                      className="w-full border-2 border-surface-300 rounded-2xl px-4 py-2"
                      value={birthYear}
                      onChange={(e) => setBirthYear(e.target.value)}
                      required
                    />
                  </div>
                ) : null}

                {/* Honeypot */}
                <div style={{ display: "none" }}>
                  <label htmlFor="contact-website">Website</label>
                  <input
                    id="contact-website"
                    name="website"
                    type="text"
                    value={website}
                    onChange={(e) => setWebsite(e.target.value)}
                    autoComplete="off"
                    tabIndex={-1}
                  />
                </div>

                {/* Opt-in */}
                <div className="flex items-center gap-3">
                  <input
                    id="contact-optin"
                    name="optin"
                    type="checkbox"
                    className="w-6 h-6 rounded-sm bg-white border-2 border-surface-300 appearance-none relative
                         checked:bg-cta-yellow checked:border-black
                         after:content-[''] after:absolute after:w-[14px] after:h-[7px]
                         after:border-[4px] after:border-ink-950 after:border-t-0 after:border-r-0
                         after:-rotate-45 after:scale-0 after:left-[3px] after:top-[5px]
                         checked:after:scale-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-black"
                    checked={optIn}
                    onChange={(e) => setOptIn(e.target.checked)}
                  />
                  <label htmlFor="contact-optin" className="text-black text-xs md:text-sm">
                    Sign me up for updates about new games and class tools!
                  </label>
                </div>

                {/* Submit */}
                <div className="pt-2 flex justify-center">
                  <button
                    type="submit"
                    className="inline-block bg-cta-yellow text-black px-10 py-4 md:py-5 rounded-full charlie-kingdom-font text-xl md:text-2xl hover:bg-cta-yellow-hover shadow-cta-yellow border-4 border-black disabled:opacity-60"
                    disabled={loading}
                  >
                    <span className="relative -top-1">
                      {loading ? "Sending..." : "Send Message"}
                    </span>
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
